module.exports = __webpack_public_path__ + "img/home_icon_funeng_normal.c9345170.png";